<template>
  <div class="container">
    <v-card>
      <v-toolbar dark color="primary">
        <v-toolbar-title>Gestión de Enfermeros</v-toolbar-title>
      </v-toolbar>

      <v-form ref="form" v-model="valid" :lazy-validation="lazy">
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-chip label color="transparent" text-color="black">
                <h3>Búsqueda de Enfermeros</h3>
              </v-chip>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6" sm="4">
              <v-text-field
                v-model="apellido"
                prepend-icon="mdi-account"
                label="Apellidos"
                maxlength="80"
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6" sm="4">
              <v-text-field
                v-model="nombre"
                prepend-icon="mdi-account"
                label="Nombres"
                maxlength="80"
                dense
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
      </v-form>
      <v-card-actions class="mt-0 pt-0">
        <v-spacer></v-spacer>
        <v-btn
          :disabled="!valid"
          color="primary"
          @click.stop="buscarEnfermeros()"
        >
          Buscar
          <v-icon dark right>mdi-magnify</v-icon>
        </v-btn>
      </v-card-actions>

      <v-data-table
        v-if="listaEnfermeros.length"
        :headers="headers"
        :items="this.listaEnfermeros"
        class="elevation-1"
        locale="es-ar"
        item-key="idObraSocial"
        :items-per-page="10"
        ref="myTable"
        :disable-sort="true"
        :footer-props="{
          itemsPerPageText: 'Filas por página',
        }"
      >
        <template v-slot:item.actions="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                medium
                color="purple"
                class="mr-3"
                v-on="on"
                v-bind="attrs"
                @click.stop="editarEnfermero(item)"
                >mdi-pencil</v-icon
              >
            </template>
            <span>Editar Enfermero</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                medium
                v-on="on"
                color="red"
                v-bind="attrs"
                @click="borrarEnfermero(item)"
                >mdi-delete</v-icon
              >
            </template>
            <span>Eliminar Enfermero</span>
          </v-tooltip>
        </template>
      </v-data-table>
      <v-alert class="mt-4" color="purple" dark outlined v-else>
        No hay enfermeros configurados para la institución.
      </v-alert>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="success" @click.stop="nuevoEnfermero"
          >Nuevo Enfermero</v-btn
        >
        <v-btn
          color="warning"
          :disabled="listaEnfermeros.length < 1"
          @click.stop="imprimir"
          >Imprimir</v-btn
        >
        <v-btn color="error" @click.stop="salir">Salir</v-btn>
      </v-card-actions>
      <NuevoEnfermero
        :visible="showNuevoEnfermero"
        @close="cierraNuevoEnfermero()"
        @enfermeroRegistrado="enfermeroRegistrado()"
      ></NuevoEnfermero>
      <EditarEnfermero
        :visible="showEditarEnfermero"
        :idEnfermero="editedItem.idEnfermero"
        @close="cierraEditarEnfermero()"
        @enfermeroModificado="enfermeroModificado()"
      ></EditarEnfermero>
    </v-card>
  </div>
</template>
<style scoped>
::v-deep .v-data-table__empty-wrapper {
  display: none;
}
</style>
<script>
import axios from "../../axios-auth.js";
import router from "../../router/index.js";
import jsPDF from "jspdf";
import autotable from "jspdf-autotable";
import NuevoEnfermero from "./NuevoEnfermero.vue";
import EditarEnfermero from "./EditarEnfermero.vue";
export default {
  data: (vm) => ({
    valid: false,
    lazy: false,
    nombre: null,
    apellido: null,
    listaEnfermeros: [],
    headers: [
      { text: "Apellidos", value: "apellido" },
      { text: "Nombres", value: "nombre" },
      { text: "Acciones", value: "actions" },
    ],
    showNuevoEnfermero: false,
    showEditarEnfermero: false,
    editedItem: {},
    editedIndex: -1,
  }),
  methods: {
    salir() {
      router.push({ path: "/Home" });
    },

    showAlert(alertInfo) {
      alertInfo.vm.$swal.fire({
        icon: alertInfo.icon,
        title: alertInfo.title,
        showConfirmButton: false,
        background: "#ececec",
        timer: 1500,
      });
    },
    borrarEnfermero(item) {
      this.$swal({
        title: "Borrar Enfermero",
        text: "¿Desea borrar el enfermero?",
        icon: "success",
        background: "#ececec",
        showClass: {
          popup: "animate__animated animate__fadeInDown",
        },
        hideClass: {
          popup: "animate__animated animate__fadeOutUp",
        },
        showCancelButton: true,
        confirmButtonText: "Si",
        cancelButtonText: "No",
        showCloseButton: true,
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          const idEnfermero = item.idEnfermero;
          let self = this;
          axios
            .get("/Enfermeria/BorrarEnfermero?", {
              params: {
                idEnfermero: idEnfermero,
              },
            })
            .then((response) => {
              if (response.data == "error") {
                self.showAlert({
                  icon: "error",
                  title: "El enfermero tiene transacciones asociadas",
                  vm: self,
                });
              } else {
                self.showAlert({
                  icon: "success",
                  title: "Enfermero borrado exitosamente",
                  vm: self,
                });
                setTimeout(self.buscarEnfermeros(), 1700);
              }
            })
            .catch((error) => {
              self.showAlert({
                icon: "error",
                title: "El enfermero no pudo ser borrado",
                vm: this,
              });
            });
        } else {
        }
      });
    },
    cierraNuevoEnfermero() {
      this.showNuevoEnfermero = false;
    },
    cierraEditarEnfermero() {
      this.showEditarEnfermero = false;
    },
    enfermeroRegistrado() {
      this.showNuevoEnfermero = false;
      this.buscarEnfermeros();
    },
    enfermeroModificado() {
      this.showEditarEnfermero = false;
      this.buscarEnfermeros();
    },
    nuevoEnfermero() {
      this.showNuevoEnfermero = true;
    },
    editarEnfermero(item) {
      this.editedIndex = this.listaEnfermeros.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.showEditarEnfermero = true;
    },
    buscarEnfermeros() {
      const filtrosData = {
        apellido: this.apellido,
        nombre: this.nombre,
        idInstitucion: this.$store.state.usuario.institucion.idInstitucion,
      };

      let self = this;
      axios
        .get("/Enfermeria/GetEnfermerosNomDeInst?", {
          params: {
            apellido: filtrosData.apellido,
            nombre: filtrosData.nombre,
            idInstitucion: filtrosData.idInstitucion,
          },
        })
        .then(function(response) {
          if (response.data != null && response.data != "")
            self.listaEnfermeros = response.data;
          else {
            self.listaEnfermeros = [];
          }
        })
        .catch(function(error) {});
    },
    imprimir() {
      var source = this.$refs["myTable"];
      let rows = [];
      let columnHeader = ["Apellidos", "Nombre"];
      source.items.forEach((element) => {
        var temp = [element.apellido, element.nombre];
        rows.push(temp);
      });
      var doc = new jsPDF();
      doc.setProperties({
        title: "Listado Enfermeros",
      });
      var nombreInstitucion = this.$store.state.usuario.institucion.nombreInstitucion
        .toString()
        .trim();

      doc.setFontSize(12);
      doc.text(nombreInstitucion, 13, 10);
      doc.setFontSize(10);

      doc.setFontSize(16);
      doc.text(
        "Listado de Enfermeros",
        doc.internal.pageSize.getWidth() / 2,
        33,
        { align: "center" }
      );
      doc.autoTable(columnHeader, rows, {
        startY: 39,
        didParseCell: function(table) {
          if (table.section === "head") {
            table.cell.styles.fillColor = "#c4c5c5";
          }
        },
      });

      window.open(doc.output("bloburl"), "_blank");
    },
  },
  created() {
    this.buscarEnfermeros();
  },
  components: {
    NuevoEnfermero,
    EditarEnfermero,
  },
};
</script>
